// extracted by mini-css-extract-plugin
module.exports =  {"pf-date":"pf-date--TrCmu","pfDate":"pf-date--TrCmu"};